<template>
    <section class="news-items">
        <news-item-large
            v-if="index % 5 === 0"
            :item="item"
            class="news-item news-item--large"></news-item-large>
        <news-item-small v-else :item="item" class="news-item news-item--small"></news-item-small>
    </section>
</template>

<script setup lang="ts">
import newsItemSmall from './news-item-small.component.vue';
import newsItemLarge from './news-item-large.component.vue';
import { INewsArticle } from '../model/news-overview.model';
defineProps<{
    item: INewsArticle;
    index: number;
}>();
</script>
